import React from 'react'
import Button from '../components/Button'
import Tip from '../components/Tip'
import DotSelect from '../components/DotSelect'
import TreatmentQueue from '../components/TreatmentQueue'

class DotSelectPage extends React.Component {
  constructor() {
    super()
    this.state = {
      selected: 0,
      toggledBoxes: [],
    }
    this.handleBoxToggle = this.handleBoxToggle.bind(this)
  }
  static defaultProps = {
    setWrapperState: () => {},
    wrapperState: [],
  }

  handleBoxToggle(e, index) {
    const { toggledBoxes } = this.state
    if (e) {
      this.setState({
        toggledBoxes: toggledBoxes.concat([index]),
      })
    } else {
      this.setState({
        toggledBoxes: toggledBoxes.filter(i => i !== index),
      })
    }
    this.onToggle(e, index)
  }

  onNext() {
    if (this.props.wrapperState.purpose === undefined) {
      this.props.setWrapperState({
        purpose: this.props.wrapperState.currPage - 3,
      })
    }
    this.props.setWrapperState({
      currPage: this.props.data.nextPageIndex,
    })
  }

  onToggle(e, index) {
    const { data, setWrapperState, wrapperState } = this.props
    const condition = data.options[index].condition
    let newCondition = ""
    if(typeof condition !== 'string'){
      if(wrapperState.gender === 2){
        newCondition = condition.male
      }
      else {
        newCondition = condition.female
      }
    }
    else{
      newCondition = condition
    }
    const newTreatmentID = data.options[index].treatmentID
    if (e) {
      setWrapperState({
        toggledBoxes: wrapperState.toggledBoxes.concat([index]),
        conditions: wrapperState.conditions.concat([newCondition]),
        selectedTreatments: wrapperState.selectedTreatments.concat([
          newTreatmentID,
        ]),
      })
    } else {
      setWrapperState({
        toggledBoxes: wrapperState.toggledBoxes.filter(i => i !== index),
        conditions: wrapperState.conditions.filter(i => i !== newCondition),
        selectedTreatments: wrapperState.selectedTreatments.filter(
          i => i !== newTreatmentID
        ),
      })
    }
  }

  onBack() {
    const { prevPageIndex: currPage } = this.props.data
    this.setState({ selected: 0 })
    this.props.setWrapperState({
      currPage,
      toggledBoxes: [],
      conditions: [],
      selectedTreatments: [],
    })
  }

  getTip(data) {
    return data.tipContent
  }

  render() {
    const { toggledBoxes, gender, age, skinType } = this.props.wrapperState
    const { data } = this.props
    const dotLocations = []
    const boxes = data.options
      .filter(op => {
        return op.skinTypes.includes(skinType) && op.ages.includes(age)
      })
      .map(op => {
        var box = op.box
        var dotLocation = op.dotLocation
        if (typeof op.box.content !== 'string') {
          if (gender === 2) {
            box.content = box.content.male
            if (box.content.reference) {
              box.references = box.content.reference
              box.content = box.content.desc
            }
          } else {
            box.content = box.content.female
            if (box.content.reference) {
              box.references = box.content.reference
              box.content = box.content.desc
            }
          }
        }
        if (typeof op.box.title !== 'string') {
          if (gender === 2) {
            box.title = box.title.male
          } else {
            box.title = box.title.female
          }
        }
        if (op.dotLocation[0] === undefined) {
          if (gender === 2) {
            dotLocation = dotLocation.male
          } else {
            dotLocation = dotLocation.female
          }
        }
        dotLocations.push(dotLocation)
        return box
      })
    var imageLoc = data.dotImage
    if (typeof imageLoc !== 'string') {
      imageLoc = gender === 2 ? imageLoc.male : imageLoc.female
    }
    const dotProps = {
      image: imageLoc,
      locations: dotLocations,
      dotSize: 20,
    }

    return (
      <div>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <div className="dot-select-header-container">
            <h1>{data.header}</h1>
            <h3>{data.subHeader}</h3>
            <p>{data.subsubheader}</p>
          </div>
          {!!toggledBoxes.length && (
            <div className="treatment-queue-wrapper">
              <TreatmentQueue
                boxes={boxes}
                data={data}
                onToggle={this.handleBoxToggle}
                toggledBoxes={toggledBoxes}
              />
            </div>
          )}
        </div>
        <div className="dotSelectWrapper">
          <DotSelect
            width={data.totalWidth}
            height={data.imgHeight}
            dotProps={dotProps}
            boxes={boxes}
            toggledBoxes={toggledBoxes}
            onToggle={this.handleBoxToggle}
          />
        </div>
        <Tip marginTop="100px" title={data.tipHeader}>
          {data.tipContent}
        </Tip>
        <div className="footer">
          <div className="bottomButtons">
            <div>
              {!!data.prevButton && (
                <Button shape="round" onClick={() => this.onBack()}>
                  {data.prevButton}
                </Button>
              )}
            </div>
            <Button
              shape="round"
              variant="blue"
              onClick={() => this.onNext()}
              disabled={toggledBoxes.length === 0}
            >
              {data.nextButton}
            </Button>
          </div>
        </div>
      </div>
    )
  }
}

export default DotSelectPage
